/**
 * Standardized focus styles for consistent focus ring handling across the application
 *
 * This helps eliminate browser default blue outlines while maintaining accessibility
 */

export const FOCUS_STYLES = {
  // For standard interactive elements (preferred - keyboard only focus)
  // Uses focus-visible to only show focus ring when navigating with keyboard
  standard:
    'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',

  // For elements that need focus indication on both keyboard and mouse interactions
  always: 'focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',

  // For overlay buttons with translucent/glassmorphism backgrounds
  // Uses white ring with transparency to show on dark overlay backgrounds
  overlay:
    'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/60 focus-visible:ring-offset-2 focus-visible:ring-offset-black/20',

  // For close buttons and similar UI controls
  close: 'focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',

  // For form elements within containers
  formContainer:
    'focus-within:outline-none focus-within:ring-2 focus-within:ring-ring focus-within:ring-offset-2',
} as const;

/**
 * Usage examples:
 *
 * // Standard interactive button
 * <button className={`px-4 py-2 ${FOCUS_STYLES.standard}`}>
 *
 * // Overlay "Click to Close" button
 * <button className={`glassmorphism-neutral ${FOCUS_STYLES.overlay}`}>
 *
 * // Close button (X)
 * <button className={`absolute top-2 right-2 ${FOCUS_STYLES.close}`}>
 */
